import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetWorkingAreasQuery } from "../../../app/globalApi";
import TabsComponent from "../../../components/shared/tabs/TabsComponent";
import StaffAttendanceReportTab from "./StaffAttendanceReportTab";
import useTranslator from "../../../hooks/useTranslator";

const allowedTabs = [
  "Manager",
  "Nursing",
  "Safety",
  "General Cleaning",
  "Other",
];

const AttendenceReport = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(null);
  const [tabsData, setTabsData] = useState([]);
  const { data: workingAreas, isLoading } = useGetWorkingAreasQuery();

  useEffect(() => {
    if (workingAreas && workingAreas.data) {
      const tabs = [];
      workingAreas.data.forEach((workingArea) => {
        if (allowedTabs.includes(workingArea.name)) {
          tabs.push({
            label: workingArea.name,
            eventKey: workingArea.id,
            content: <></>,
          });
        }
      });
      setTabsData(tabs);
    }
  }, [workingAreas]);

  useEffect(() => {
    if (tabsData.length > 0) {
      setActiveKey(tabsData[0].eventKey);
    }
  }, [tabsData]);

  useEffect(() => {
    if (activeKey) {
      addQueryParam("activeTab", activeKey);
    }
  }, [activeKey]);

  const addQueryParam = (key, value) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set(key, value);
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  return (
    <div>
      {isLoading && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
      {!isLoading && activeKey && (
        <>
          {/* <div className="overview cmn_card">
          <div className="overview_header d-flex gap-2 align-items-center">
            <h6 className="mb-0 flex-grow-1">Attendance Reports</h6>
          </div>
        </div> */}
          <div className="tabs_outer">
            <TabsComponent
              tabs={tabsData}
              defaultKey={activeKey}
              layout="horizontal"
              setActiveKey={setActiveKey}
            />
            <div className="tabs_content">
              <StaffAttendanceReportTab tab={activeKey} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AttendenceReport;
